import axiosInstance from './AxiosInstance';

const API_URL = 'tasknumber';

export const getTaskNumbers = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching tasknumbers', error);
        throw error;
    }
};

export const getTaskNumberById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching tasknumber with id ${id}`, error);
        throw error;
    }
};

export const createTaskNumber = async (tasknumber) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, tasknumber);
        return response.data;
    } catch (error) {
        console.error('Error creating tasknumber', error);
        throw error;
    }
};

export const updateTaskNumber = async (tasknumber) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, tasknumber );
        return response.data;
    } catch (error) {
        console.error(`Error updating tasknumber with id ${tasknumber?.id}`, error);
        throw error;
    }
};

export const deleteTaskNumber = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting tasknumber with id ${id}`, error);
        throw error;
    }
};

export const getTaskNumber = async (id) =>{
    try {
        const response = await axiosInstance.post(`${API_URL}/getTaskNumber`, { id: id })
        return response.data;
    } catch (error) {
        console.error(`Error deleting tasknumber with id ${id}`, error);
        throw error;
    }
};

export const importExcel = async (data) => {
    try {
      const response = await axiosInstance.post(
        `${API_URL}/import-excel`,
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error import-excel project code", error);
      throw error;
    }
  };

